import React from 'react'
import { useTranslation } from 'react-i18next'
import SideNavItem from '@/component/layout/SideNav/SideNavItem.tsx'
import RailTooltip from '@/component/layout/SideNav/RailTooltip.tsx'
import { useNavItems } from '@/component/layout/SideNav/navItems.ts'
import { SidebarIcon } from '@/component/layout/ShellIcons.tsx'
import { useSideNavStore } from '@/store/SideNavStore.ts'

type IProps = {
    className?: string;
}

const SIDE_NAV_ID = 'app-side-nav'

const SideNav: React.FunctionComponent<IProps> = ({ className }) => {
    const { t } = useTranslation()
    const navItems = useNavItems()
    const isCollapsed = useSideNavStore((state) => state.isCollapsed)
    const toggleCollapsed = useSideNavStore((state) => state.toggleCollapsed)
    const toggleLabel = isCollapsed ? t('sideNav.expand') : t('sideNav.collapse')

    // 지도·차트처럼 창 크기에 맞추는 화면이 폭이 다 바뀐 뒤 다시 재도록 알린다
    const onTransitionEnd = (e: React.TransitionEvent) => {
        if (e.target === e.currentTarget && e.propertyName === 'width') {
            window.dispatchEvent(new Event('resize'))
        }
    }

    return (
        <aside
            id={SIDE_NAV_ID}
            className={`${className} app-side-nav ${isCollapsed ? 'app-side-nav--rail' : ''}`}
            onTransitionEnd={onTransitionEnd}
        >
            <nav className={'app-side-nav__menu'} aria-label={'Main navigation'}>
                {navItems.map(item => <SideNavItem key={item.id} {...item} isRail={isCollapsed} />)}
            </nav>
            <div className={'app-side-nav__bottom'}>
                <RailTooltip label={toggleLabel} enabled={isCollapsed}>
                    <button
                        type={'button'}
                        className={'app-side-nav__toggle'}
                        aria-expanded={!isCollapsed}
                        aria-controls={SIDE_NAV_ID}
                        aria-label={toggleLabel}
                        onClick={toggleCollapsed}
                    >
                        <SidebarIcon className={'app-side-nav__toggle-icon'} />
                        <span className={'app-side-nav__label'}>{toggleLabel}</span>
                    </button>
                </RailTooltip>
            </div>
        </aside>
    )
}

export default SideNav
